export default __webpack_public_path__ + "static/media/video-3.a4cb051a.jpg";